import { 
    AnimationPropertiesOverride,
    Matrix, Mesh,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    IPointerEvent,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    PickingInfo,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    PointerEventTypes,
    Camera,
} from "@babylonjs/core";

import type { dispatch } from '@wordpress/data';

import { AnimationHandler } from "./AnimationHandler";
import { ViewDetails } from "./view";

type WordpressDataModule = {
    dispatch: typeof dispatch;
}

type Wordpress = {
    data: WordpressDataModule;
}

declare const wp: Wordpress;

export class ManipulationHandler{
    
    public ClickedTransformNodes: string[] = [];
    public BlendSpeed: number=0.25;
    private _animationhandler: AnimationHandler;
    private _details: ViewDetails;
    private _camera: Camera;
    
    private _mouseX: number;
    private _mouseY: number;
    private _click: boolean=true;
    private _margin: number=5;

    constructor(animationhandler: AnimationHandler, details: ViewDetails, camera: Camera)
    {
        this._details = details
        this._camera = camera;
        this._animationhandler = animationhandler;
        
        details.scene.onPointerDown = this.StartInterval.bind(this)
        details.scene.onPointerUp =  this.CastRay.bind(this)

        

    }
    StartInterval(/*evt: IPointerEvent, _pickInfo: PickingInfo,  type: PointerEventTypes*/)
    {
       this._mouseX =this._details.scene.pointerX;
       this._mouseY = this._details.scene.pointerY;
    }
    CastRay(/*evt: IPointerEvent, pickInfo: PickingInfo,  type: PointerEventTypes*/)
    {
        if(this._details.scene.pointerX > this._mouseX+this._margin)
            this._click=false;
        if(this._details.scene.pointerX < this._mouseX-this._margin)
            this._click=false;
        if(this._details.scene.pointerY > this._mouseY+this._margin)
            this._click=false;
        if(this._details.scene.pointerY < this._mouseY-this._margin)
            this._click=false;
        

        if (this._click) {
            wp?.data?.dispatch('core/block-editor').selectBlock(this._details.view.UniqueId);

            console.log("ClickDown")
            const ray = this._details.scene.createPickingRay(
                this._details.scene.pointerX, this._details.scene.pointerY, Matrix.Identity(), this._camera
                );
            const hit = this._details.scene.pickWithRay(ray);
            if (hit.pickedMesh) {
                let hitMesh = hit.pickedMesh as Mesh;
                while (hitMesh) {
                    //function to call animations
                    for (let i = 0; i < this._animationhandler.MeshesWithAnimations.length; i++) {
                        if (hitMesh.name == this._animationhandler.MeshesWithAnimations[i].name) {
                            for (let j = 0; j < this._details.scene.animationGroups.length; j++) {
                                const split = this._details.scene.animationGroups[j].name.split("_");
                                const splicedStr = split.slice(0, split.length - 1).join("_");
                                if (this._animationhandler.MeshesWithAnimations[i].name == splicedStr) {
                                    if (this.ClickedTransformNodes.includes(this._animationhandler.MeshesWithAnimations[i].name)) {
                                        this._animationhandler.MeshesWithAnimations[i].animationPropertiesOverride = new AnimationPropertiesOverride()
                                        this._animationhandler.MeshesWithAnimations[i].animationPropertiesOverride.enableBlending = true
                                        this._animationhandler.MeshesWithAnimations[i].animationPropertiesOverride.blendingSpeed = this.BlendSpeed;
                                        const index = this.ClickedTransformNodes.indexOf(this._animationhandler.MeshesWithAnimations[i].name)
                                        this.ClickedTransformNodes.splice(index, 1);
                                        if (this._details.scene.animationGroups[j].isPlaying) {
                                            console.log("curent frame " + Math.floor(this._details.scene.animationGroups[j].targetedAnimations[0]?.animation.runtimeAnimations[0]?.currentFrame ?? 0))
                                            console.log("length " + Math.floor(this._details.scene.animationGroups[j].targetedAnimations[0]?.animation.getKeys()[1].frame));
                                            const currentFrame = Math.floor(this._details.scene.animationGroups[j].targetedAnimations[0]?.animation.runtimeAnimations[0]?.currentFrame ?? 0);
                                            const length = Math.floor(this._details.scene.animationGroups[j].targetedAnimations[0]?.animation.getKeys()[1].frame);
                                            const deltaFrame = (length - currentFrame)
                                            this._details.scene.beginAnimation(this._animationhandler.MeshesWithAnimations[i], deltaFrame, this._details.scene.animationGroups[j + 1].to);
                                        }
                                        else
                                            this._details.scene.animationGroups[j + 1].play();
                                        break;
                                    }
                                    if (this._details.scene.animationGroups[j + 1].isPlaying) {
                                        console.log("curent frame " + Math.floor(this._details.scene.animationGroups[j + 1].targetedAnimations[0]?.animation.runtimeAnimations[0]?.currentFrame ?? 0))
                                        console.log("length " + Math.floor(this._details.scene.animationGroups[j].targetedAnimations[0]?.animation.getKeys()[1].frame));
                                        const currentFrame = Math.floor(this._details.scene.animationGroups[j + 1].targetedAnimations[0]?.animation.runtimeAnimations[0]?.currentFrame ?? 0);
                                        const length = Math.floor(this._details.scene.animationGroups[j].targetedAnimations[0]?.animation.getKeys()[1].frame);
                                        const deltaFrame = (length - currentFrame)
                                        console.log(deltaFrame)
                                        this._details.scene.beginAnimation(this._animationhandler.MeshesWithAnimations[i], deltaFrame, this._details.scene.animationGroups[j].to);

                                    }
                                    else
                                        this._details.scene.animationGroups[j].play();
                                    this.ClickedTransformNodes.push(this._animationhandler.MeshesWithAnimations[i].name);
                                    break;
                                }

                            }
                        }
                    }
                    hitMesh = hitMesh.parent as Mesh
                }
            }
        }
        this._click = true;
    }

}